"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _isFixed = _interopRequireDefault(require("./isFixed"));
var _shouldBreak = _interopRequireDefault(require("./shouldBreak"));
var _getWrap = _interopRequireDefault(require("./getWrap"));
var _split2 = _interopRequireDefault(require("./split"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable no-continue */

// eslint-disable-next-line import/no-cycle

// eslint-disable-next-line import/no-cycle

// Prevent splitting elements by low decimal numbers
var SAFTY_THRESHOLD = 0.001;
var getTop = R.pathOr(0, ['box', 'top']);
var getHeight = R.path(['box', 'height']);
var isElementOutside = R.useWith(R.lte, [R.identity, getTop]);
var warnUnavailableSpace = function warnUnavailableSpace(node) {
  console.warn("Node of type " + node.type + " can't wrap between pages and it's bigger than available page height");
};
var splitNodes = function splitNodes(height, contentArea, nodes) {
  var currentChildren = [];
  var nextChildren = [];
  for (var i = 0; i < nodes.length; i += 1) {
    var _child$children;
    var child = nodes[i];
    var futureNodes = nodes.slice(i + 1);
    var futureFixedNodes = R.filter(_isFixed.default, futureNodes);
    var nodeTop = getTop(child);
    var nodeHeight = getHeight(child);
    var isOutside = isElementOutside(height, child);
    var shouldBreak = (0, _shouldBreak.default)(child, futureNodes, height, contentArea);
    var shouldSplit = height + SAFTY_THRESHOLD < nodeTop + nodeHeight;
    var canWrap = (0, _getWrap.default)(child);
    var fitsInsidePage = nodeHeight <= contentArea;
    if ((0, _isFixed.default)(child)) {
      nextChildren.push(child);
      currentChildren.push(child);
      continue;
    }
    if (isOutside) {
      var next = R.evolve({
        box: {
          top: R.subtract(R.__, height)
        }
      })(child);
      nextChildren.push(next);
      continue;
    }
    if (!fitsInsidePage && !canWrap) {
      currentChildren.push(child);
      nextChildren.push.apply(nextChildren, futureNodes);
      warnUnavailableSpace(child);
      break;
    }
    if (shouldBreak) {
      var _next = R.evolve({
        box: {
          top: R.subtract(R.__, height)
        },
        props: R.evolve({
          wrap: R.always(true),
          break: R.always(false)
        })
      })(child);

      //removed pushing futureFixedNodes into currentChildren to prevent footnote duplication with keep settings
      //currentChildren.push(...futureFixedNodes);
      nextChildren.push.apply(nextChildren, [_next].concat(futureNodes));
      break;
    }

    /**
     * should call split also if any child have break prop
     */
    var anyChildHasBreak = (_child$children = child.children) === null || _child$children === void 0 ? void 0 : _child$children.some(function (childItem) {
      var _childItem$props;
      return !!((_childItem$props = childItem.props) !== null && _childItem$props !== void 0 && _childItem$props.break);
    });
    if (shouldSplit || anyChildHasBreak) {
      var _split = (0, _split2.default)(child, height, contentArea),
        currentChild = _split[0],
        nextChild = _split[1];
      if (currentChild) currentChildren.push(currentChild);
      if (nextChild) nextChildren.push(nextChild);
      continue;
    }
    currentChildren.push(child);
  }
  return [currentChildren, nextChildren];
};
var _default = exports.default = splitNodes;